// @ts-nocheck
import {
    chain,
    LoadRealTimeInventory as baseLoadRealTimeInventory,
    LoadRealTimePrices as baseLoadRealTimePrices,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePrices = createChainHandler("LoadRealTimePrices", chain, async props => {
    if (props.products?.some(x => !x.isVariantParent)) {
        await baseLoadRealTimePrices(props);
    }
});

replaceInChain(chain, baseLoadRealTimePrices, LoadRealTimePrices);

export const LoadRealTimeInventory = createChainHandler("LoadRealTimeInventory", chain, props => {
    if (props.products?.some(x => !x.isVariantParent)) {
        baseLoadRealTimeInventory(props);
    }
});

replaceInChain(chain, baseLoadRealTimeInventory, LoadRealTimeInventory);
